import { z } from "zod/v4";

import { ExperienceCategoryList } from "../../../dtos/experience-categories";
import { ExperienceListDtoSchema } from "../../../dtos/experiences-list";
import { castToNumber } from "../../../utils";

export const GetExperiencesListQueryParamSchema = z.object({
  category: z.enum(ExperienceCategoryList).optional(),
  limit: castToNumber.optional(),
  page: castToNumber.optional(),
});

export type GetExperiencesListQueryParamType = z.infer<
  typeof GetExperiencesListQueryParamSchema
>;

export const GetExperiencesListResponseBodySchema = z.object({
  experiencesList: ExperienceListDtoSchema.array(),
  page: z.number().optional(),
});

export type GetExperiencesListResponseBodyType = z.infer<
  typeof GetExperiencesListResponseBodySchema
>;
